import Cookies from 'js-cookie'

export const initHotjar = () => {
  const hotjarScript = document.getElementById('hotjarScript')

  if (!hotjarScript) {
    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('id', 'hotjarScript')
    script.innerHTML = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:3674522,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
    window.document.body.appendChild(script)
  }
}

const removeCookies = () => {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    if (cookieName.startsWith('_hj')) {
      Cookies.remove(cookieName, { path: '/', domain: '.zoi.com' })
      Cookies.remove(cookieName, { path: '/', domain: '.hotjar.com' })
    }
  })
}

const deleteScripts = () => {
  const hotjarMainScript = document.getElementById('hotjarScript')

  if (hotjarMainScript) {
    hotjarMainScript.parentNode?.removeChild(hotjarMainScript)
  }

  // Remove Hotjar scripts
  const hotjarHeadScripts = document.querySelectorAll(
    'script[src*="hotjar.com"]'
  )
  hotjarHeadScripts.forEach((script) => {
    script.parentNode?.removeChild(script)
  })
}

const deleteIframe = () => {
  const hotjarIframe = document.querySelector('iframe[title="_hjSafeContext"]')

  if (hotjarIframe) {
    hotjarIframe.parentNode?.removeChild(hotjarIframe)
  }
}

export const destroyHotjar = () => {
  removeCookies()
  deleteScripts()
  deleteIframe()
}
